import {
  searchAddresses,
  searchAddressesResultSet,
} from 'redux/modules/address-suggestion/actions/search-for-addresses';
import { addressSuggestionNavigation } from 'redux/modules/address-suggestion/selectors';
import { updateNavigation } from 'redux/modules/address-suggestion/actions/update-navigation';

export const navigateBackSuggestedAddress = () => async (dispatch, getState) => {
  const navigation = addressSuggestionNavigation(getState());
  if (navigation.length > 2) {
    dispatch(updateNavigation(navigation.slice(0, navigation.length - 2)));
    dispatch(searchAddressesResultSet(navigation[navigation.length - 2]));
  } else if (navigation.length > 0) {
    dispatch(updateNavigation([]));
    dispatch(searchAddresses(navigation[0]));
  }
};
